import { FormProcessor } from "./formprocessor";
import { AnalyticsProcessor } from "./analytics";
import { ValidationProcessor } from "./validationprocessor";
import { onLoadAcquisitonKeyEncryption } from "./utility";

const formProcessor = new FormProcessor();
const  analyticsProcessor = new AnalyticsProcessor();
const  validationProcessor = new ValidationProcessor();

try {
	window.onload = function() {
		onLoadAcquisitonKeyEncryption();
	}
}
catch(err) {
	console.error(`window onload issue ${err}`);
}

export {
	formProcessor,
	analyticsProcessor,
	validationProcessor
};